import { Box, Button, Grid, Typography } from "@mui/material";
import { MainContainer } from "../../components/MainContainerComp";
import { ITheme } from "../../utils/theme";
import { bulletParagraphStyle } from "../paid-personal-leave-request/components/LeaveDetails/styled";

interface IPaidPersonalLeaveRequestSubmittedRouteProps {
  onClose: () => void;
}

export const PaidPersonalLeaveRequestSubmitted: React.FC<IPaidPersonalLeaveRequestSubmittedRouteProps> = ({
  onClose
}) => {
  return (
    <MainContainer>
      <Grid container sx={{ justifyContent: 'center' }} spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue, mb: 1, mt: 2, px: 1 }}>Your leave application has been received. It will be processed within 30 days.</Typography>
          <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue, mb: 1, mt: 2, px: 1 }}>We've sent a confirmation email to your address. Please check your inbox (and spam folder).</Typography>
          <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue, mb: 0, mt: 2, px: 1 }}>Delays may occur if application is incomplete.</Typography>
          <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue, mb: 10, mt: 2, px: 1 }}>Feel free to close this window.</Typography>
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Button variant="contained" onClick={onClose}>Close</Button>
          </Box>
        </Grid>
      </Grid>
    </MainContainer>
  )
}

